import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { TrendingUp, Eye, MessageCircle, Banknote, Star, Coins } from "lucide-react";

function Stat({ icon: Icon, label, value, hint, color = "brand" }) {
  return (
    <div className="bg-white rounded-2xl border border-border p-4">
      <div className={`h-10 w-10 rounded-xl ${color === "brand" ? "bg-brand-light text-brand" : "bg-pro/10 text-pro"} flex items-center justify-center mb-3`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="text-xs uppercase tracking-wider text-slate2">{label}</div>
      <div className="font-heading font-bold text-2xl text-ink">{value}</div>
      {hint && <div className="text-[11px] text-slate2 mt-1">{hint}</div>}
    </div>
  );
}

export default function ProActivity() {
  const { user } = useAuth();
  const [a, setA] = useState(null);

  useEffect(() => { api.get("/activity/me").then((r) => setA(r.data)); }, []);

  return (
    <AppShell role="pro" title="Mon activité">
      {!a && <div className="text-center py-10 text-slate2">Chargement…</div>}
      {a && (
        <>
          <div className="grid grid-cols-2 gap-3">
            <Stat icon={Eye} label="Vues profil" value={a.profile_views} hint="Cette semaine" />
            <Stat icon={MessageCircle} label="Messages envoyés" value={a.messages_sent} />
            <Stat icon={Banknote} label="Investi en leads" value={`${a.total_spent}€`} hint="Total cumulé" color="pro" />
            <Stat icon={Coins} label="Jetons restants" value={a.tokens} color="pro" />
            <Stat icon={TrendingUp} label="Taux conversion" value={`${a.conversion_rate}%`} />
            <Stat icon={Star} label="Note moyenne" value={a.rating} hint={`${a.reviews_count} avis`} />
          </div>

          <section className="mt-6 bg-pro text-white rounded-2xl p-5">
            <div className="text-[10px] uppercase tracking-widest text-white/60 mb-1">Conseil IA Pro</div>
            <h3 className="font-heading font-bold text-lg leading-tight mb-2">
              Boostez votre taux de conversion
            </h3>
            <p className="text-sm text-white/80 leading-relaxed">
              Les pros qui répondent en moins de 30 min ont 4x plus de chance de décrocher
              le chantier. Activez les notifications pour ne rater aucun lead.
            </p>
          </section>

          <section className="mt-6">
            <h3 className="text-sm font-heading font-bold text-ink mb-3">Historique récent</h3>
            <div className="bg-white rounded-2xl border border-border divide-y divide-border">
              {a.leads_unlocked === 0 ? (
                <div className="p-5 text-sm text-slate2 text-center">
                  Aucun lead débloqué pour l'instant. Allez sur l'accueil pour découvrir
                  les demandes locales.
                </div>
              ) : (
                <div className="p-4 text-sm text-ink">
                  Vous avez débloqué <b>{a.leads_unlocked}</b> demande{a.leads_unlocked > 1 ? "s" : ""} et envoyé <b>{a.messages_sent}</b> message{a.messages_sent > 1 ? "s" : ""}.
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </AppShell>
  );
}
